// extracted by mini-css-extract-plugin
export default {"mCard":"zE-z","image":"AE-z","imageNoBackground":"BE-z","imageHasCategory":"CE-z","fullWidth":"DE-z"};